export const paymentSchemesFieldMapping = {
    details: [
        'id',
        'name',
        'description',
        'enabled',
        'preloadedAmount',
        'currency',
        'ecrTenderTypeCode'
    ],
    validity: [
        'startDateTime',
        'endDateTime',
    ],
    configuration: [
        'expiryPeriod',
        'expiryPeriodUnit',
        'adjustExpiryToEndOfYear',
        'unitOfMeasure',
        'unitOfMeasureType',
        'redemptionFrequencyDays',
        'requestBasketContent',
        'printPaymentVoucher'
    ]
}
